import styled from '@emotion/styled';
import { InputRoot, Label } from '../../../styledComponent/SignUpComponents.style';

export const SignupFormInputRoot = styled(InputRoot)`
  margin-bottom: 12px;
`;

export const SignupFormInputLabel = styled(Label)`
  margin-bottom: 0px;
`;

export const SignupFormWrapper = styled(InputRoot)`
  margin-bottom: 12px;
`;
